import React from 'react'
import PropTypes from 'prop-types'
import GallerySinglePickerRaw from '~/components/main/product/GallerySinglePicker'

const GallerySinglePicker = ({ field, form, disabled, ...props }) => {
  const images = React.useMemo(
    () => (field?.value ? [field.value] : []),
    [field.value],
  )
  return (
    <GallerySinglePickerRaw
      images={images}
      setFieldValue={(_, newValue) => form.setFieldValue(field.name, newValue)}
      disabled={disabled || !!form.values.__readOnly}
      {...props}
    />
  )
}

GallerySinglePicker.defaultProps = {
  onClick: () => {},
  disabled: false,
}

GallerySinglePicker.propTypes = {
  field: PropTypes.shape().isRequired,
  form: PropTypes.shape().isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default GallerySinglePicker
